import { Locale } from 'modules/i18n';

export const chainsListPageTitleTranslation = {
  [Locale.en]: {
    title: 'Chains list',
  },
};
